export const VendorDetailActiveOffersPageSize = 6;
export const VendorDetailActiveOffersPageSize = 6;
